import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-mall-demand",
  "use": "icon-soc-l1-mall-demand-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-mall-demand\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M192 288h640v448H192V288zm64 64v320h512V352H256z\" />\r\n  <path d=\"M352 192h320v64H352V192zm96 576h128v64H448v-64z\" />\r\n  <path d=\"M384 448h256v48H384v-48zm0 96h192v48H384v-48z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-mall-demand.svg
// module id = jwgA
// module chunks = 492